// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Utils_Shared$LiveRoom from "./Utils/Utils_Shared.bs.js";

var Raw = {};

var query = (require("@apollo/client").gql`
  fragment AmountFragment on Amount   {
    __typename
    currency
    amount
  }
`);

function parse(value) {
  var value$1 = value.currency;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var tmp$1;
    switch (value$1) {
      case "AED" :
          tmp$1 = "AED";
          break;
      case "ARS" :
          tmp$1 = "ARS";
          break;
      case "AUD" :
          tmp$1 = "AUD";
          break;
      case "BRL" :
          tmp$1 = "BRL";
          break;
      case "BTC" :
          tmp$1 = "BTC";
          break;
      case "CAD" :
          tmp$1 = "CAD";
          break;
      case "CHF" :
          tmp$1 = "CHF";
          break;
      case "CNY" :
          tmp$1 = "CNY";
          break;
      case "ETH" :
          tmp$1 = "ETH";
          break;
      case "EUR" :
          tmp$1 = "EUR";
          break;
      case "GBP" :
          tmp$1 = "GBP";
          break;
      case "HKD" :
          tmp$1 = "HKD";
          break;
      case "IDR" :
          tmp$1 = "IDR";
          break;
      case "INR" :
          tmp$1 = "INR";
          break;
      case "JPY" :
          tmp$1 = "JPY";
          break;
      case "KRW" :
          tmp$1 = "KRW";
          break;
      case "MXN" :
          tmp$1 = "MXN";
          break;
      case "PHP" :
          tmp$1 = "PHP";
          break;
      case "QAR" :
          tmp$1 = "QAR";
          break;
      case "RUB" :
          tmp$1 = "RUB";
          break;
      case "SAR" :
          tmp$1 = "SAR";
          break;
      case "SGD" :
          tmp$1 = "SGD";
          break;
      case "TWD" :
          tmp$1 = "TWD";
          break;
      case "USD" :
          tmp$1 = "USD";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$1
        };
    }
    tmp = tmp$1;
  }
  return {
          __typename: value.__typename,
          currency: tmp,
          amount: value.amount
        };
}

function serialize(value) {
  var value$1 = value.amount;
  var value$2 = value.currency;
  var currency = value$2 !== undefined ? (
      typeof value$2 === "object" ? value$2.VAL : (
          value$2 === "ARS" ? "ARS" : (
              value$2 === "AUD" ? "AUD" : (
                  value$2 === "BRL" ? "BRL" : (
                      value$2 === "BTC" ? "BTC" : (
                          value$2 === "CAD" ? "CAD" : (
                              value$2 === "CHF" ? "CHF" : (
                                  value$2 === "CNY" ? "CNY" : (
                                      value$2 === "ETH" ? "ETH" : (
                                          value$2 === "EUR" ? "EUR" : (
                                              value$2 === "GBP" ? "GBP" : (
                                                  value$2 === "HKD" ? "HKD" : (
                                                      value$2 === "IDR" ? "IDR" : (
                                                          value$2 === "INR" ? "INR" : (
                                                              value$2 === "JPY" ? "JPY" : (
                                                                  value$2 === "KRW" ? "KRW" : (
                                                                      value$2 === "MXN" ? "MXN" : (
                                                                          value$2 === "PHP" ? "PHP" : (
                                                                              value$2 === "QAR" ? "QAR" : (
                                                                                  value$2 === "RUB" ? "RUB" : (
                                                                                      value$2 === "SAR" ? "SAR" : (
                                                                                          value$2 === "SGD" ? "SGD" : (
                                                                                              value$2 === "TWD" ? "TWD" : (
                                                                                                  value$2 === "USD" ? "USD" : "AED"
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    ) : null;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          currency: currency,
          amount: value$1
        };
}

function verifyArgsAndParse(_AmountFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var AmountFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

function make(amount, currency, param) {
  return {
          __typename: "Amount",
          currency: Belt_Option.getWithDefault(currency, "USD"),
          amount: amount
        };
}

function format(amount) {
  return Utils_Shared$LiveRoom.Numbers.withCommas(amount);
}

function currencyToString(currency) {
  var match = Belt_Option.getWithDefault(currency, "USD");
  if (typeof match === "object") {
    return match.VAL;
  } else if (match === "ARS") {
    return "ARS";
  } else if (match === "AUD") {
    return "AUD";
  } else if (match === "BRL") {
    return "BRL";
  } else if (match === "BTC") {
    return "BTC";
  } else if (match === "CAD") {
    return "CAD";
  } else if (match === "CHF") {
    return "CHF";
  } else if (match === "CNY") {
    return "CNY";
  } else if (match === "ETH") {
    return "ETH";
  } else if (match === "EUR") {
    return "EUR";
  } else if (match === "GBP") {
    return "GBP";
  } else if (match === "HKD") {
    return "HKD";
  } else if (match === "IDR") {
    return "IDR";
  } else if (match === "INR") {
    return "INR";
  } else if (match === "JPY") {
    return "JPY";
  } else if (match === "KRW") {
    return "KRW";
  } else if (match === "MXN") {
    return "MXN";
  } else if (match === "PHP") {
    return "PHP";
  } else if (match === "QAR") {
    return "QAR";
  } else if (match === "RUB") {
    return "RUB";
  } else if (match === "SAR") {
    return "SAR";
  } else if (match === "SGD") {
    return "SGD";
  } else if (match === "TWD") {
    return "TWD";
  } else if (match === "USD") {
    return "USD";
  } else {
    return "AED";
  }
}

export {
  AmountFragment ,
  make ,
  format ,
  currencyToString ,
}
/* query Not a pure module */
